// ABOUTME: RTK Query endpoints for Amazon FBA replenishments (/amazonreplenishments).
// ABOUTME: Mirrors bolreplenishmentSlice but with placement-option endpoints and registered cache tags.
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const AMAZONREPLENISHMENT_BASE = "/amazonreplenishments";
const buildUrl = (endpoint) => AMAZONREPLENISHMENT_BASE + endpoint;

const amazonreplenishmentSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        findAllAmazonreplenishments: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'AmazonReplenishments' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'findAllAmazonreplenishments', 'AmazonReplenishments')
        }),
        findAmazonreplenishmentById: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'AmazonReplenishments', id }],
        }),
        getAmazonreplenishmentLines: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/${args.id}/lines?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: [{ type: 'AmazonReplenishmentLines' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getAmazonreplenishmentLines', 'AmazonReplenishmentLines')
        }),
        createAmazonreplenishment: builder.mutation({
            query: info => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body: info,
            }),
            invalidatesTags: [{ type: 'AmazonReplenishments' }],
        }),
        getAmazonPlacementOptions: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}/placementoptions`),
                method: 'POST',
            }),
        }),
        confirmAmazonPlacement: builder.mutation({
            query: ({ id, body }) => ({
                url: buildUrl(`/${id}/placementoptions/confirm`),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'AmazonReplenishments', id }, { type: 'AmazonReplenishments' }, { type: 'AmazonReplenishmentLines', id }],
        }),
        updateAmazonreplenishment: builder.mutation({
            query: ({ id, body }) => ({
                url: buildUrl(`/${id}`),
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'AmazonReplenishments', id }, { type: 'AmazonReplenishments' }, { type: 'AmazonReplenishmentLines', id }],
        }),
        deleteAmazonreplenishment: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'AmazonReplenishments', id }, { type: 'AmazonReplenishments' }, { type: 'AmazonReplenishmentLines', id }],
        }),
        approveAmazonreplenishment: builder.mutation({
            query: ({ id, body }) => ({
                url: buildUrl(`/${id}/approve`),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'AmazonReplenishments', id }, { type: 'AmazonReplenishments' }, { type: 'AmazonReplenishmentLines', id }],
        }),
        rejectAmazonreplenishment: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}/reject`),
                method: 'POST',
            }),
            invalidatesTags: (result, error, id) => [{ type: 'AmazonReplenishments', id }, { type: 'AmazonReplenishments' }, { type: 'AmazonReplenishmentLines', id }],
        }),
        getAmazonLabels: builder.query({
            query: ({ id, shipment }) => ({
                url: buildUrl(`/${id}/labels?shipment=${shipment}`),
                method: 'GET',
            }),
        }),
        syncAmazonreplenishmentStatus: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/${id}/syncstatus`),
                method: 'POST',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'AmazonReplenishments', id },
                { type: 'AmazonReplenishments' },
                { type: 'AmazonReplenishmentLines', id },
                { type: 'LogsSingle' }
            ],
        }),
    })
});

export const {
    useFindAllAmazonreplenishmentsQuery,
    useFindAmazonreplenishmentByIdQuery,
    useGetAmazonreplenishmentLinesQuery,
    useCreateAmazonreplenishmentMutation,
    useGetAmazonPlacementOptionsMutation,
    useConfirmAmazonPlacementMutation,
    useUpdateAmazonreplenishmentMutation,
    useDeleteAmazonreplenishmentMutation,
    useApproveAmazonreplenishmentMutation,
    useRejectAmazonreplenishmentMutation,
    useGetAmazonLabelsQuery,
    useSyncAmazonreplenishmentStatusMutation,
} = amazonreplenishmentSlice;
